import { useEffect, useState } from 'react';

import { offerTypeLabels, faqList } from '../../lib/labels';
import { getAllOffers, getBriefOffers } from './appSubscribeGetData';
import Header from '../Header';
import Footer from '../Footer';
import OfferTypeConfirm from '../OfferTypeConfirm';
import Faq from '../Faq';
import { StyledAllProducts, StyledWrapper, StyledMain } from './AppSubscribe.styles';

function AppSubscribe({ message1, message2, brief, goToURLParams }) {

  const [offers, setOffers] = useState([]);

  useEffect(async () => {
    const filteredOffers = brief
      ? await getBriefOffers([], goToURLParams)
      : await getAllOffers(goToURLParams, brief);
    setOffers(filteredOffers);
  }, []);

  return (
    <StyledWrapper hasLightBg={brief}>
      {!brief && <Header />}
      <StyledMain>
        <OfferTypeConfirm
          message1={message1 || offerTypeLabels.message1}
          message2={message2 || offerTypeLabels.message2}
        />
        <StyledAllProducts offers={offers} brief={!!brief} />
      </StyledMain>
      {!brief && (
        <>
          <Faq faqList={faqList} />
          <Footer />
        </>
      )}
    </StyledWrapper>
  );
}

export default AppSubscribe;
